export const inputStyle = {
  bg: 'white',
}

export const linkStyle = {
  color: 'brand.400',
  fontWeight: 'medium',
  fontSize: '16px',
  textDecoration: 'underline',
}

export const rowStyle = {
  pb: 4,
  borderBottom: '1px solid',
  borderColor: 'inherit',
  justifyContent: 'space-between',
}
